import { langTypes } from '../types/common';
// Collection of formatting functions

/**
 * Formats a number for display
 * @param num string or number
 * @param lang language to format to
 * @param nbDecimal the # of decimal places to format for
 */
const formatNumber = (num: string | number, lang: langTypes, nbDecimal = 0) => {
	if (num !== '-') {
		const numberSplitted = Number(num)
			.toFixed(nbDecimal)
			.toString()
			.split('.');
		const decimal = numberSplitted[1];
		if (lang === 'en') {
			let result = numberSplitted[0].replace(/(-)?(\d)(?=(\d\d\d)+(?!\d))/g, '$1$2,');
			result += typeof decimal !== 'undefined' && nbDecimal > 0 ? '.' + decimal.substring(0, nbDecimal) : '';
			return result;
		} else if (lang === 'fr') {
			let result = numberSplitted[0].replace(/(-)?(\d)(?=(\d\d\d)+(?!\d))/g, '$1$2\xa0');
			result += typeof decimal !== 'undefined' && nbDecimal > 0 ? ',' + decimal.substring(0, nbDecimal) : '';
			return result;
		}
	}
};

const formatCurrency = (num: string | number, lang: langTypes = 'en', nbDecimal = 0, currencySymbol = '$') => {
	if (lang === 'en') {
		if (currencySymbol !== '%') {
			return currencySymbol + formatNumber(num, 'en', nbDecimal);
		} else {
			return formatNumber(num, 'en', nbDecimal) + currencySymbol;
		}
	} else if (lang === 'fr') {
		return formatNumber(num, 'fr', nbDecimal) + '\xa0' + currencySymbol;
	}
};

export { formatNumber, formatCurrency };
